<div class="workflow-area" data-uiid="new-eff-workflow-bar">
    @if (stepsConfigs) {
        <eff-workflow-bar [steps]="stepsConfigs"></eff-workflow-bar>
    }
</div>
